<template>
  <el-card>
    <div class="chat">
      <div class="chat-header clearfix">
        <div class="chat-about">
          <el-avatar
            class="alignAvatar"
            v-if="conversation.talkTo.avatar"
            fit="cover"
            size="large"
          >
            <img
              loading="lazy"
              title="用户图片"
              alt="用户图片"
              :src="conversation.talkTo.avatar"
            />
          </el-avatar>
          <el-avatar
            v-else
            style="vertical-align:middle"
            size="large"
            icon="el-icon-user-solid"
          >
          </el-avatar>
          &nbsp;<span v-if="conversation.talkTo.id == user.id"
            ><b>备忘录</b></span
          >
          <router-link v-else :to="'/users/' + conversation.talkTo.id">
            <span class="chat-with">{{ conversation.talkTo.name }}</span>
          </router-link>
        </div>
      </div>
      <!-- end chat-header -->

      <div class="chat-history" id="chatHistory" ref="chatHistory">
        <div style="text-align: center">
          <i
            class="el-icon-loading"
            style="font-size:30px"
            v-show="loading"
          ></i>
        </div>
        <div v-if="id === undefined">
          <h4 class="text-center">选择用户进行聊天</h4>
        </div>
        <section v-else>
          <EachMessage
            v-for="message in reverseMessages"
            :message="message"
            :key="message.id"
          ></EachMessage>
        </section>
      </div>
      <p class="text-center" v-show="hasNewMessages">有新信息</p>
      <div class="chat-message clearfix">
        <el-input
          id="message-data"
          v-model="newMessageBody"
          placeholder="回车或按钮发送"
          @keyup.enter.native="sendMessage()"
        >
          <el-button
            slot="append"
            class="btn-primary"
            @click="sendMessage"
            size="large"
          >
            <font-awesome-icon icon="paper-plane" />
          </el-button>
        </el-input>
      </div>
      <!-- end chat-message -->
    </div>
    <!-- end chat -->
  </el-card>
</template>
<script>
/* eslint-disable no-undef */

import EachMessage from "./EachMessageComponent.vue";
import Event from "../../event.js";
import { mapState } from "vuex";

export default {
  data: function() {
    return {
      newMessageBody: "",
      messages: [],
      hasMore: true,
      shouldLoad: false,
      gotLastResponse: true,
      hasNewMessages: false,
      shouldScrollToBottom: true,
      loading: false,
      conversation: {
        id: 0,
        status: 0,
        unread_count: 0,
        last_message: null,
        talkTo: {
          id: 0,
          name: "",
          avatar: ""
        }
      }
    };
  },
  props: ["id"],
  computed: {
    ...mapState(["user"]),
    reverseMessages() {
      return this.messages.slice().reverse();
    }
  },
  mounted: function() {
    this.fetchConversation();
    var self = this;
    var chatHistory = $(".chat-history");
    chatHistory.scroll(function() {
      if (
        self.shouldLoad &&
        self.hasMore &&
        self.gotLastResponse &&
        this.scrollTop < 200
      ) {
        self.shouldLoad = false;
        self.shouldScrollToBottom = false;
        self.fetchMessages(true);
      }
      if (this.scrollTop > 300) {
        self.shouldLoad = true;
      }
      if (
        this.scrollTop > chatHistory[0].scrollHeight - 600 &&
        self.hasNewMessages
      ) {
        self.hasNewMessages = false;
      }
    });
    Event.$on("message.received", message => {
      if (this.messages.length > 0 && message.id <= this.messages[0].id) {
        return;
      }
      if (this.conversation.id === null) {
        this.conversation.id = message.conversation_id;
      }
      // if the current conversation is the the conversation the message is sent to.
      if (this.conversation.id === message.conversation_id) {
        self.messages.unshift(message); // prepend to current conversation's messages
        if (this.user.id === message.user_id) {
          // if it's my own message, scroll to the bottom.
          this.shouldScrollToBottom = true;
          // this.scrollToBottom();
        } else {
          // if the message is sent by the TalkTo.
          this.conversation.unread_count++;
          this.hasNewMessages = true;
          this.shouldScrollToBottom = false;
        }
      }
      //   } else{
      //       if(lastId != 0)
      //       {
      //         this.shouldScrollToBottom = false;
      //           $(`#message-${lastId}`)[0].scrollIntoView({
      //             behavior: "instant", block: "start", inline:
      //               "nearest"
      //           });
      //       }
      // }
    });
  },
  updated() {
    this.scrollToBottom();
  },
  methods: {
    fetchMessages: function(loadMore = false) {
      if (
        this.conversation != undefined &&
        this.conversation.id != undefined &&
        this.hasMore
      ) {
        var url = `/conversations/${this.conversation.id}/messages`;

        // this is to make sure after new messages are loaded, the scroll bar is still on the previous message
        var previousLastId = 0;
        if (loadMore) {
          previousLastId = this.messages[this.messages.length - 1].id;
          url += "?last_msg_id=" + previousLastId;
        }
        this.$http.get(url).then(res => {
          if (res.data.length > 0) {
            this.hasMore = true;
            res.data.forEach(msg => {
              this.messages.push(msg);
              if (loadMore) {
                //scroll to previous message place before the new message load
                this.scrollToMessage(previousLastId);
              }
            });
          } else {
            this.hasMore = false;
          }
        });
      }
    },
    fetchConversation: function() {
      if (this.id != undefined) {
        this.$http.get(`/conversations/user/${this.id}`).then(res => {
          this.conversation = res.data;
          this.fetchMessages();
          this.markRead();
        });
      }
    },
    markRead: function() {
      if (this.conversation.unread_count !== 0) {
        this.$http
          .get(`/conversations/${this.conversation.id}/read`)
          .then(() => {
            this.conversation.unread_count = 0;
            Event.$emit("conversation.mark.read", this.conversation);
          });
      }
    },
    sendMessage() {
      this.markRead();
      if (
        this.newMessageBody != "" &&
        this.conversation != undefined &&
        this.conversation.talkTo != undefined &&
        this.conversation.talkTo.id != 0
      ) {
        this.$http
          .post("/messages", {
            talk_to_id: this.conversation.talkTo.id,
            message_body: this.newMessageBody
          })
          .then(response => {
            // this.messages.unshift(response.data.message);
            this.newMessageBody = "";
            // reuse the message received event, so that conversation list can confirm the last message sent.
            Event.$emit("message.received", response.data);
          });
      }
    },
    scrollToBottom: function() {
      if (this.shouldScrollToBottom) {
        var chatHistory = $("#chatHistory");
        chatHistory.scrollTop(chatHistory[0].scrollHeight);
        this.hasNewMessages = false;
      }
    },
    scrollToMessage: function(messageId) {
      if (!this.shouldScrollToBottom) {
        $("#message-" + messageId)[0].scrollIntoView({
          behavior: "instant",
          block: "start",
          inline: "nearest"
        });
      }
    }
  },
  components: {
    EachMessage
  },
  created() {
    this.$http.interceptors.request.use(
      config => {
        // trigger 'loading=true' event here
        this.loading = true;
        return config;
      },
      error => {
        this.loading = false;
        // trigger 'loading=false' event here
        return Promise.reject(error);
      }
    );

    this.$http.interceptors.response.use(
      response => {
        this.loading = false;
        // trigger 'loading=false' event here
        return response;
      },
      error => {
        this.loading = false;
        // trigger 'loading=false' event here
        return Promise.reject(error);
      }
    );
  },
  watch: {
    hasNewMessages: function(newVal, oldVal) {
      if (!newVal && oldVal) {
        // if newVal == false, oldVal == true
        this.markRead();
      }
    }
  }
};
</script>

<style>
.chat {
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  color: #434651;
}

.chat .chat-header {
  background: var(--color-canvas-subtle);
  padding: 20px;
}

.chat .chat-header img {
  float: left;
}

.chat .chat-header .chat-about {
  float: left;
  padding-left: 10px;
  margin-top: 6px;
}

.chat .chat-header .chat-with {
  font-weight: bold;
  font-size: 16px;
}

.chat .chat-header svg {
  float: right;
  color: #d8dadf;
  font-size: 20px;
  margin-top: 12px;
}

.chat .chat-history {
  padding: 30px 30px 20px;
  border: 2px solid var(--color-canvas-subtle);
  overflow-y: scroll;
  height: 55vh;
}

.chat .chat-message {
  background: var(--color-canvas-subtle);
  padding: 10px;
}

.chat .chat-message textarea {
  width: 100%;
  border: none;
  padding: 10px 20px;
  font: 14px/22px "Lato", Arial, sans-serif;
  margin-bottom: 10px;
  border-radius: 5px;
  resize: none;
}

.chat .chat-message button {
  float: right;
  /*color: #94C2ED;*/
  font-size: 16px;
  text-transform: uppercase;
  border: none;
  cursor: pointer;
  font-weight: bold;
  /*background: #F2F5F8;*/
}

.chat .chat-message button:hover {
  color: #75b1e8;
}

.clearfix:after {
  visibility: hidden;
  display: block;
  font-size: 0;
  content: " ";
  clear: both;
  height: 0;
}
</style>
